import { ClassNameProps, If, makeClassName, StyleProps } from "@hex-insights/core";
import { Badge } from "../../../../Components/Badge";
import { AttendanceStatus } from "../../../../Utilities";
import { AttendanceStatusFormat } from "../../../Format";
import { AttendanceStatusUtilities } from "../../../Utilities";
import styles from "./styles.module.css";

export type AttendanceStatusBadgeProps = {
	attendanceStatus: Pick<
		AttendanceStatus,
		| "name"
		| "code"
		| "description"
		| "indicatesAbsent"
		| "indicatesLateArrival"
		| "indicatesEarlyDeparture"
		| "indicatesExcused"
	> | null;
	extended?: boolean;
} & Partial<ClassNameProps & StyleProps>;

export function AttendanceStatusBadge({
	attendanceStatus,
	extended = false,
	className,
	style,
}: AttendanceStatusBadgeProps) {
	const backgroundColor = AttendanceStatusUtilities.backgroundColor(attendanceStatus);
	let title = "No Attendance Record";
	if (attendanceStatus) {
		title = AttendanceStatusFormat.name(attendanceStatus);
		if (attendanceStatus.description) {
			title += "\n\n" + AttendanceStatusFormat.Fields.description(attendanceStatus.description);
		}
	}

	return (
		<Badge
			backgroundColor={backgroundColor}
			className={makeClassName(styles["attendance-status-badge"], className)}
			style={style}
			title={title}
		>
			{!!attendanceStatus ? AttendanceStatusFormat.Fields.code(attendanceStatus.code) : "N/A"}
			{!!attendanceStatus && <If condition={extended}> : {AttendanceStatusFormat.name(attendanceStatus)}</If>}
		</Badge>
	);
}
